import { render, staticRenderFns } from "./CardDiagnostico.vue?vue&type=template&id=20a846b2&scoped=true&"
import script from "./CardDiagnostico.vue?vue&type=script&lang=js&"
export * from "./CardDiagnostico.vue?vue&type=script&lang=js&"
import style0 from "./CardDiagnostico.vue?vue&type=style&index=0&id=20a846b2&prod&lang=css&"
import style1 from "./CardDiagnostico.vue?vue&type=style&index=1&id=20a846b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a846b2",
  null
  
)

export default component.exports